import React from 'react'
import SlideNew from '../../SlideNew/SlideNew'
import MultiCarousel from '../../MultiCarousel/MultiCarousel'
import CardRond from '../../CardRond/CardRond'
import Citation from '../../Citation/Citation'
import MultiCAgenda from '../../MulticAgenda/MultiCAgenda'
import ScrollAnimation from 'react-animate-on-scroll';
import OffreTarifHome from '../../OffreTarifHome/OffreTarifHome'

import { Link} from 'react-router-dom'


const Home = () => {

  return (
    <>
      <div className="mb-5 ">

          <SlideNew />   

      </div>

      <div className='container-xl mt-5'>
        <ScrollAnimation animateIn='bounceInRight' > 
            <MultiCarousel />
        </ScrollAnimation>
      </div>

      <div className="container-fluid bg-light mx-auto m-3 test123">
        <ScrollAnimation animateIn='bounceInRight' > 
          <CardRond />
        </ScrollAnimation>
      </div>

      <div className="container-xl mx-auto m-3">
        <ScrollAnimation animateIn='bounceInRight'> 
          <MultiCAgenda />
        </ScrollAnimation>
      </div>

      <div className="container-fluid bg-light my-5 py-5">
        <ScrollAnimation animateIn='bounceInRight'> 
          <Citation />
        </ScrollAnimation>
      </div>

      <div className="container-fluid ">
      <ScrollAnimation animateIn='bounceInRight'> 
          <Link to="/NousRejoindre" className="text-decoration-none text-dark">
            <OffreTarifHome />
          </Link>
        </ScrollAnimation>
      </div>
    </>
  )
}

export default Home



